import {
  quoteStatusAdapter,
  scheduleStatusAdapter
} from 'Cube/utils/status.adapter'
import { useCubeData } from './useCubeData'
import { CubeStatus } from '../cube.domain.types'

/**
 * Returns the status of the current entity, as well as whether it is a quote,
 * schedule, or template.
 * @returns
 */
export const useStatus = () => {
  const { data } = useCubeData()

  return {
    status: data.common.status,
    isAQuote: !!quoteStatusAdapter.out(data.common.status),
    isASchedule: !!scheduleStatusAdapter.out(data.common.status),
    isAQuoteTemplate: data.common.status === CubeStatus.QuoteTemplate
  }
}
